module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show),
      expression: "show"
    }],
    staticClass: "componens"
  }, [_c('div', {
    staticClass: "w3-row"
  }, [_c('div', {
    staticClass: "w3-twothird"
  }, [_c('div', {
    staticClass: "text-container"
  }, [_vm._v("\n          Ez az oldal sütiket használ a felhasználói élmény fokozása érdekében.\n          "), (!_vm.isLandingPage) ? _c('router-link', {
    staticClass: "cookie-bar-prompt-button",
    attrs: {
      "to": "/adatvedelmi-nyilatkozat"
    }
  }, [_vm._v("Részletek")]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "w3-third button-container"
  }, [_c('button', {
    staticClass: "w3-button w3-pink",
    on: {
      "click": function($event) {
        return _vm.setCookie('acceptedCookies', 'true', 365)
      }
    }
  }, [_vm._v("\n          Sütik elfogadása\n        ")])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6e9e8a5c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/CookieBar.vue
// module id = 945
// module chunks = 0